var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { CheckCircle, Info, Sparkle, WarningCircle, XCircle } from '@phosphor-icons/react';
import { SIGNAL_VARIANTS } from '../../utils/signalVariants';
import { Inline } from '../inline/Inline';
import { iconStyleVariants, messageVariants } from './Notice.css';
const { CAUTION, CRITICAL, POSITIVE, INFORMATION } = SIGNAL_VARIANTS;
const iconVariants = {
    [CAUTION]: WarningCircle,
    [CRITICAL]: XCircle,
    [INFORMATION]: Info,
    [POSITIVE]: CheckCircle,
    promotional: Sparkle,
};
export const Notice = React.forwardRef(function Notice(_a, ref) {
    var { children, className, icon, variant = POSITIVE } = _a, rest = __rest(_a, ["children", "className", "icon", "variant"]);
    const DefaultIcon = iconVariants[variant];
    return (_jsxs(Inline, Object.assign({ alignY: "top", className: cx(messageVariants[variant], className), noWrap: true, spacing: 8 }, rest, { ref: ref, children: [icon !== null && icon !== void 0 ? icon : _jsx(DefaultIcon, { className: iconStyleVariants[variant], weight: "bold" }), children] })));
});
